import PropTypes from 'prop-types';
const TileViewIcon = ({ width, height }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
            <mask id="mask0_2022_3108" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                <rect width="24" height="24" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_2022_3108)">
                <path d="M5 11.1765V5H11.1765V11.1765H5ZM5 19V12.8235H11.1765V19H5ZM12.8235 11.1765V5H19V11.1765H12.8235ZM12.8235 19V12.8235H19V19H12.8235ZM6.23529 9.94118H9.94118V6.23529H6.23529V9.94118ZM14.0588 9.94118H17.7647V6.23529H14.0588V9.94118ZM14.0588 17.7647H17.7647V14.0588H14.0588V17.7647ZM6.23529 17.7647H9.94118V14.0588H6.23529V17.7647Z" fill="var(--react-select-text)" />
            </g>
        </svg>
    )
};

TileViewIcon.propTypes = {
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default TileViewIcon;